import {Component, Input, OnInit} from '@angular/core';
import {NgbModal, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {LandingComponent} from "../../landing/landing.component";
import {InviteAFriendComponent} from "../../modals/invite-a-friend/invite-a-friend.component";
import {EventsManager} from "../../../events/events.manager";
import {environment} from "../../../../environments/environment";
import { Router } from '@angular/router';
import { GoogleAnalyticsService } from 'src/app/services/google-analytics.service';

@Component({
  selector: 'app-subheader',
  templateUrl: './subheader.component.html',
  styleUrls: ['./subheader.component.scss']
})
export class SubheaderComponent implements OnInit {
office: any = {};
environment:any = environment;
info: any = {};
currentRoute: string = '';
  constructor(private em: EventsManager, public modalService: NgbModal, private router: Router, private googleAnalyticsService: GoogleAnalyticsService) {
    this.router.events.subscribe(() => {
      this.currentRoute = this.router.url;
    });
  }

  ngOnInit(): void {
    this.office = this.em.getOfficeInfo();
    this.em.officeUpdate.subscribe(
      (result) => {
        this.office = result;
      }
    )

    this.em.contactInfoUpdated.subscribe(
      (info:any) => {
        this.info = this.em.contactInfo;
      }
    )
  }

  inviteAFriend(){
    const modalRef: NgbModalRef = this.modalService.open(InviteAFriendComponent);
    modalRef.result.then(
      (result: any) => {
        this.closeModal();
      },
      error => {
        console.log('error: ',error);
      }
    )
  }

  closeModal() {
    this.modalService.dismissAll();
  }
  onCall() {
    this.googleAnalyticsService.sendKeyEvent('click_to_call', {
      timestamp: new Date().toISOString()
    })
  }
  memberLogin() {
    this.googleAnalyticsService.sendKeyEvent('Click_member_login', {
      timestamp: new Date().toISOString()
    })
  }

  findDentist() {
    this.googleAnalyticsService.sendKeyEvent('find_dentist', {
      timestamp: new Date().toISOString()
    })
  }
}
